import auth0 from 'auth0-js';
import decode from 'jwt-decode';
import { EVO } from './EVO';
import { AUTH_CONFIG } from './Auth0Config';
import { roles } from './constants';

export default class AuthService {

    auth0 = new auth0.WebAuth({
        domain: AUTH_CONFIG.domain,
        clientID: AUTH_CONFIG.clientID,
        redirectUri: this.redirectUrl(AUTH_CONFIG.startSession),
        audience: AUTH_CONFIG.audience,
        responseType: 'token id_token',
        scope: 'openid profile email name'
    });

    static instance = null;
    static getInstance() {
        if (AuthService.instance == null) {
            AuthService.instance = new AuthService();
        }

        return AuthService.instance;
    }

    redirectUrl(relativeUrl) {
        if (process.env.NODE_ENV === 'development') {
            let url = AUTH_CONFIG.devRedirectUri + relativeUrl;
            if (window.location.href.indexOf('5001') > -1) {
                url = url.replace('44390', '5001');
            }
            return url;
        }
        if (document.location.host.indexOf('stag') > -1)
            return AUTH_CONFIG.stagingRedirectUri + relativeUrl;

        return AUTH_CONFIG.redirectUri + relativeUrl;
    }

    login() {
        this.auth0.authorize();
    }

    handleAuthentication(history, callback) {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);
                history.push("/");
                if (callback) {
                    callback();
                }
            } else if (err) {
                console.log(err);
            }
        });
    }

    setSession(authResult) {
        EVO.storage.set('access_token', authResult.accessToken);
        EVO.storage.set('id_token', authResult.idToken);
    }

    isAuthenticated() {
        var user = this.getUser();
        return user !== null;
    }

    getAccessToken(allowAnon) {
        const accessToken = EVO.storage.get('id_token');
        if (!accessToken && !allowAnon) {
            throw new Error('No access token found');
        }
        return accessToken;
    }

    setAsClient(client) {
        if (this.userInRoles([roles.Admin])) {
            EVO.storage.set('pt_asclient', {
                asClientId: client.id,
                asClientName: client.name
            });
        }
    }

    removeAsClient() {
        EVO.storage.remove('pt_asclient');
    }

    isViewingAsClient() {
        return this.userInRoles([roles.Admin]) && EVO.storage.get('pt_asclient');
    }

    getUser() {
        const token = EVO.storage.get('id_token');
        if (token) {
            try {
                const decoded = decode(token);
                if (decoded.exp > Date.now() / 1000) { // Checking if token is expired. N
                    var asClient = {};
                    var userRoles = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || [];
                    if (userRoles.includes(roles.Admin)) {
                        const cookieVal = EVO.storage.get('pt_asclient');
                        if (cookieVal) {
                            asClient = cookieVal;
                        }
                    }

                    return Object.assign(asClient, {
                        name: decoded.nickname || decoded.email,
                        picture: decoded.picture,
                        roles: userRoles
                    });
                }

                return null;
            }
            catch (err) {
                return null;
            }
        }

        return null;
    }

    logout(ignoreRedirect) {
        EVO.storage.remove('access_token');
        EVO.storage.remove('id_token');
        if (!ignoreRedirect) {
            const url = this.redirectUrl('');
            window.location.href = `https://${AUTH_CONFIG.domain}/v2/logout?returnTo=${encodeURIComponent(url)}&client_id=${AUTH_CONFIG.clientID}`;
        }
    }

    isAdmin(checkViewingAsClient) {
        return this.userInRoles([roles.Admin], checkViewingAsClient);
    }

    userInRoles(rolesInput, checkViewingAsClient) {
        if (this.isAuthenticated()) {
            if (rolesInput) {
                const user = this.getUser();
                const userRoles = (user || {}).roles || [];
                if (userRoles.length > 0) {
                    if (checkViewingAsClient && this.isViewingAsClient()) {
                        const ind = userRoles.indexOf(roles.Admin);
                        if (ind > -1) {
                            userRoles.splice(ind, 1);
                            userRoles.push(roles.Owner);
                        }
                    }
                }

                let roleIntersection = rolesInput.filter(r => userRoles.includes(r));
                if (roleIntersection.length > 0) {
                    return true;
                }
            }
            else {
                return true;
            }
        }

        return false;
    }
}


// WEBPACK FOOTER //
// ./src/AuthService.js